import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Nullable } from '../../../../@types/Nullable';
import { RootState } from '../../../../@types/RootState';

type Mechanism = {
  mechanismType?: string | null;
  factor?: number | null;
  minimumVariation?: number | null;
  priceCompetitorIndicator?: number | null;
  additionalMechanism?: string | null;
  currentMechanism?: string | null;
};

export type RuleCompositionData = {
  ruleId?: string | null;
  name?: string | null;
  productFamily?: boolean | null;
  recurrence?: {
    startingDate?: string | null;
    recurrenceType?: string | null;
    expirationDate?: string | null;
    daysOfWeek?: string[] | null;
    lastSuggestionPrice?: string | null;
    nextSuggestionPrice?: string | null;
  } | null;
  author?: string | null;
  mechanism: Partial<Nullable<Mechanism>>;
  additionalMechanism: Partial<Nullable<Mechanism>>;
  currentMechanism?: string | null;
};

type State = {
  isOpen: boolean;
  data: null | RuleCompositionData;
};

const initialState: State = {
  isOpen: false,
  data: null,
};

const slice = createSlice({
  name: 'ipa.priceManager.modals.ruleComposition',
  initialState,
  reducers: {
    SET_IS_OPEN: (state, action: { payload: boolean }) => {
      state.isOpen = action.payload;
    },
    SET_DATA: (state, action: PayloadAction<State['data']>) => {
      state.data = action.payload;
    },
  },
});

export const { SET_IS_OPEN, SET_DATA } = slice.actions;

export default slice.reducer;

export const selectorRuleComposition = (state: RootState) => {
  return state.ipa.priceManager.modals.ruleComposition;
};
